import { useEffect } from 'react';

import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import Breadcrumb from '@/components/Breadcrumb/Breadcrumb';
import PartnerGrid from '@/components/PartnerGrid/PartnerGrid';
import { ROUTE } from '@/constants/route';
import { BreadcrumbItem } from '@/services/types/Breadcrumb';

import styles from './styles.module.css';

export const PartnerAccess: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumbItems: BreadcrumbItem[] = [
    { label: 'Connexion', path: ROUTE.LOGIN },
    { label: 'Accès espaces gestionnaires', path: ROUTE.ACCESPARTENAIRES },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className={styles.partnerAccess}>
      <Breadcrumb items={breadcrumbItems} alternative />

      <MtxGrid row>
        <MtxGrid col={12} colXl={12} colLg={12} colMd={12} colSm={12} colXs={12}>
          <h3 className={styles.partnerAccessTitle}>{t('partnerInfo.title')}</h3>
        </MtxGrid>
      </MtxGrid>

      <PartnerGrid trackingContext="catalogue" />
    </div>
  );
};
